module.exports = __webpack_public_path__ + "static/media/siren.87a6636c.svg";